export type PerformanceMetric = 'timely-response' | 'guest-satisfaction';
export enum PerformanceTier {
  basic = 'Starter',
  bronze = 'Bronze',
  silver = 'Silver',
  gold = 'Gold',
}
export const TierKeys = Object.keys(
  PerformanceTier,
) as (keyof typeof PerformanceTier)[];
